"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// @ts-nocheck
exports.default = {};